import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageValleiry: React.FC = () => (
  <LocalSeoPage
    city="Valleiry"
    slug="depannage-informatique-valleiry"
    metaTitle="Dépannage Informatique Valleiry | Technicien PC Local"
    metaDescription="Technicien informatique à Valleiry. Dépannage PC, Mac, virus, optimisation. Intervention rapide à domicile ou à distance."
    intro="Votre ordinateur vous cause des soucis à Valleiry ? Un technicien informatique local intervient rapidement, à votre domicile ou à distance. PC lent, virus, WiFi en panne ou Windows bloqué — on s'occupe de tout avec un diagnostic gratuit et un devis clair."
    postalCode="74520"
    nearbyTowns={[
      { name: 'Viry', link: '/depannage-informatique-viry' },
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Annemasse', link: '/depannage-informatique-annemasse' },
      { name: 'Vers' },
      { name: 'Feigères' },
      { name: 'Chênex' },
      { name: 'Andilly' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Viry', href: '/depannage-informatique-viry' },
      { label: 'Assistance PC à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique à Annemasse', href: '/depannage-informatique-annemasse' },
      { label: 'Dépannage informatique dans le Genevois', href: '/depannage-informatique-genevois' },
    ]}
  />
);

export default DepannageValleiry;
